module.exports = __webpack_public_path__ + "img/linkedin.3c43feff.jpg";